import Destination from '@/interfaces/api/destination.interface';
import ForestGameAttributes, {ForestGameSettings} from '@/interfaces/entities/forest-game.interface';
import axios, {AxiosResponse} from 'axios';
import {Observable, of, from, Subject} from 'rxjs';
import {delay} from 'rxjs/operators';

declare const Mammadaba: any;
declare const Joomla: any;

export default class ApiService {

    public whenVisitedChanged: Subject<void> = new Subject();
    public whenFavoritesChanged: Subject<void> = new Subject();
    private static instance: ApiService;

    private constructor() {
    }

    public static getInstance(): ApiService {
        if (!ApiService.instance) {
            ApiService.instance = new ApiService();
        }
        return ApiService.instance;
    }

    public value(key: string): any {
        return Mammadaba.Api[key];
    }

    public destinations(): Destination[] {
        return this.value('Destinations');
    }

    public forestGame(): ForestGameAttributes {
        return this.value('ForestGame');
    }

    public forestGameSettings(): ForestGameSettings {
        return this.value('ForestGameSettings') || [];
    }

    public visited(): string[] {
        return this.value('Visited') || [];
    }

    public favorites(): { type: string, id: number }[] {
        return this.user().favorites || [];
    }

    public routes(): { [name: string]: string } {
        return this.value('Routes');
    }

    public toggleVisited(id: string, visited: boolean): void {
        const action: string = visited ? 'add' : 'remove';
        const url: string = 'index.php?option=com_mammadaba_profile&view=visited&format=json&' + Joomla.getOptions('csrf.token') + '=1&action=' + action;
        axios.post(url, {
            id: id
        }).then(() => {
            const index = this.visited().findIndex((checkVisited: string | number) => {
                return checkVisited.toString() === id;
            });
            index >= 0
                ? Mammadaba.Api.Visited.splice(index, 1)
                : Mammadaba.Api.Visited.push(id);
            this.whenVisitedChanged.next();
        });
    }

    public toggleMyFavorite(id: string, favorite: boolean): void {
        if (!this.user().isAuthenticated) {
            return;
        }
        // toggle favorite happens ... somewhere else
        const index = this.favorites().findIndex((checkFavorite: { id: number }) => {
            return checkFavorite.id.toString() === id;
        });
        index >= 0
            ? Mammadaba.Api.User.favorites.splice(index, 1)
            : Mammadaba.Api.User.favorites.push({type: 'map-object', id: Number(id)});
        // emit event after delay that will allow to make request ... somewhere
        of(null).pipe(delay(1)).subscribe(() => this.whenFavoritesChanged.next());
    }

    public user(): any {
        return this.value('User') || {};
    }

    public forestGameStart(gameId: string): Observable<AxiosResponse> {
        const url: string = `/index.php?option=com_mammadaba_map&view=game&id=${gameId}&format=json&action=startGame`;
        const promise: Promise<any> = axios.post(url, {
            id: gameId,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });
        return from(promise);
    }

    public forestGameSendAnswer(formData: FormData): Observable<AxiosResponse> {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const url: string = `/index.php?option=com_mammadaba_map&view=game&format=json&action=saveAnswers&timeZone=${timeZone}`;
        return from(axios.post(url, formData));
    }

    public forestGameResult(gameId: string): Observable<AxiosResponse> {
        const url: string = `/index.php?option=com_mammadaba_map&view=game&id=${gameId}&format=json&action=result`;
        const promise: Promise<any> = axios.post(url);
        return from(promise);
    }
}
